import { Component } from "react";
import { connect } from "react-redux";
// import {change_header} from '../../../redux/actions/HeroBarAction'
import {
  set_datapage,
  SetLanguage,
  getLanguage,
} from "@ora/recursos/src/redux/actions/DataPageAction";

import { Button, Card, Section, Form } from "react-bulma-components";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import $ from "jquery";
import dt from "datatables.net";
import { Link, Redirect, useHistory } from "react-router-dom";
import { tagActivo, buttonsAcciones } from "helpers/Datatables";
import Swal from "sweetalert2";
import { PageLength } from "helpers/Datatables";
$.DataTable = dt;

class EstadoRecursosImportadosPais extends Component {
  state = {
    body: [],
    listType: [],
    listPais: [],
    isloadsearch: true,
    total: "",
  };
  filter = {
    buscar: "",
    type: -1,
  };
  table = null;
  datatable = null;
  requestInit = null

  constructor(props) {
    super(props);
    this.requestInit = axios.CancelToken.source()
  }
  componentDidMount() {
    this.props.set_datapage({
      titulo: "Reporte Paises Miembros",
      isbackend: true,
      breadcrumb: [
        { name: "Intranet", url: "#" },
        { name: "Recursos", url: "#" },
        { name: "Reporte Paises Miembros", url: "#", active: true },
      ],
    });
    this.getData()
  }
  getData = () => {
    axios.get(baseUrl('cites/intranet/reportes/estado_recursos_importados_pais'), {cancelToken: this.requestInit.token}).then(res => {
      let body = []
        res.data?.data?.forEach((item, index) => {
          body.push(
            <tr key={ 'I' + index }>
              <td>{ item.pais }</td>
              <td>{ item.bd_interoperable }</td>
              <td>{ item.bd_upload }</td>
              <td>{ item.cargados }</td>
              <td>{ item.interpretacion }</td>
              <td>{ item.homo_cites }</td>
              <td>{ item.homo_uicn }</td>
              <td>{ item.homo_amazonica }</td>
              <td>{ item.completadas }</td>
              <td>{ item.publicas }</td>
              <td>{ item.deshabilitados }</td>
            </tr>
          )
        })


      this.setState({
        body
      })
    })
  }
  render() {
    return (
      <Section className="is-main-section">
        <Card>
          {/* <Card.Header> */}
          {/* <Card.Header.Title>
                     <span className="icon"><i className="mdi mdi-finance"></i></span>Importar
                 </Card.Header.Title> */}

          {/* </Card.Header> */}
          <Card.Content>
            <div className="table-wrapper has-mobile-cards table-container">
              <table className="table db-trafico is-striped is-hoverable">
                <thead>
                  <tr>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable is-current-sort"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">PAÍS</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">DB_INTEROPERABLE</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">DB_UPLOAD</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">CARGADOS</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">INTERPRETACIÓN</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable has-text-centered"
                      colSpan="3"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">HOMOLOGACIÓN</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">COMPLETADOS</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">PUBLICADOS</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      rowSpan="2"
                      className="is-sortable is-unselectable has-text-centered"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">DESHABILITADOS</span>
                      </div>
                    </th>
                    
                  </tr>
                  <tr>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable is-current-sort"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">CITES</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable is-current-sort"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">UICN</span>
                      </div>
                    </th>
                    <th
                      draggable="false"
                      className="is-sortable is-unselectable is-current-sort"
                    >
                      <div className="th-wrap has-text-centered">
                        <span className="is-relative">AMAZÓNICAS</span>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>{this.state.body}</tbody>
                {/* {this.state.modals} */}
              </table>
            </div>
          </Card.Content>
        </Card>
      </Section>
    );
  }
}

export default connect(getLanguage, { set_datapage, SetLanguage })(
  EstadoRecursosImportadosPais
);
